<template>
  <div class="f-image-card-uploader">
    <el-upload
      :class="{ 'is-limit': files.length >= limit }"
      list-type="picture-card"
      :action="url"
      :show-file-list="true"
      :file-list="files"
      :limit="limit"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
    >
      <i class="el-icon-plus" />
      <span v-show="showLimit && limit !== 1" class="num-tips"
        >{{ uploadedFiles.length }} / {{ limit }}</span
      >
    </el-upload>
    <f-image v-show="false" :id="previewImageId" :src="previewImageUrl" />
  </div>
</template>

<script>
export default {
  name: "FImageCardUploader",
  props: {
    // 上传地址
    url: {
      type: String,
      default: process.env.VUE_APP_API_HOST,
    },
    // 传入的文件列表
    files: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 最大允许上传个数
    limit: {
      type: Number,
      default: 1,
    },
    // 缩略图显示宽度
    width: {
      type: String,
      default: "80px",
    },
    // 是否显示数量限制
    showLimit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      previewImageId:
        "preview-" + +new Date() + (Math.random() * 1000).toFixed(0),
      previewImageUrl: "",
      uploadedFiles: this.files,
    };
  },
  computed: {},
  methods: {
    // 格式化文件数组，抛出change事件
    emitChange() {
      const result = [];
      this.uploadedFiles.forEach((item) => {
        if (item.id) {
          result.push({
            id: item.uid,
            url: item.url,
          });
        } else if (item.response) {
          result.push({
            id: item.uid,
            url: item.response.url,
          });
        }
      });
      this.$emit("change", result);
    },
    handlePreview(file) {
      this.previewImageUrl = file.url;
      this.$nextTick(() => {
        document
          .getElementById(this.previewImageId)
          .dispatchEvent(new Event("click"));
      });
    },
    handleRemove(file, fileList) {
      // 禁止远程删除文件
      this.uploadedFiles = fileList;
      this.emitChange(fileList);
    },
    handleExceed() {
      this.$message.error(`最多上传 ${this.limit} 张图片！`);
    },
    beforeUpload(file) {
      const formatArr = ["image/jpeg", "image/png"];
      if (formatArr.indexOf(file.type) === -1) {
        this.$message.error("上传图片格式只支持 jpg、 png！");
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("上传图片大小不能超过 2M！");
        return false;
      }
      return true;
    },
    handleSuccess(response, file, fileList) {
      this.uploadedFiles = fileList;
      if (!response.errno) {
        this.emitChange(fileList);
        this.$emit("getup", response);
      }
    },
  },
};
</script>

<style lang="scss" slot-scoped>
.f-image-card-uploader {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    .el-upload-list__item-status-label {
      background: #07c160;
    }
  }
  .el-upload {
    position: relative;
    width: 80px;
    height: 80px;
    line-height: 78px;
    padding-top: 5px;
    .num-tips {
      position: absolute;
      bottom: 4px;
      right: 4px;
      line-height: 1;
      color: #ccc;
      font-size: 13px;
    }
  }

  .is-limit .el-upload {
    display: none;
  }
  .el-icon-plus::after {
    content: "\E6D9";
  }
}
</style>
